import { ChangeDetectorRef, Component, input, InputSignal, OnDestroy } from "@angular/core";
import {Node}                                                                            from "../../../../_model";
import {DomSanitizer}                                              from "@angular/platform-browser";
import {DataProvider}                                              from "../../../services/data/data";
import {ActivatedRoute, Router}                                    from "@angular/router";
import {UserProvider}                                              from "../../../services/user/user";
import {FileComponent}                                             from "../../node/file/file.component";
import {AppstatusProvider}      from "../../../services/appstatus";
import {CommonModule, Location} from "@angular/common";
import {FileActionsComponent}   from "../../../components/file-actions/file-actions";
import {FormsModule} from "@angular/forms";
import {VideoPlayerComponent} from "../../../components/video-player/video-player.component";
import {MatButtonModule}                                                                 from "@angular/material/button";
import {FilePathPipe} from "../../../pipes/file-path.pipe";
import {CaptionPipe} from "../../../pipes/caption.pipe";
import {GetIconPipe} from "../../../pipes/get-icon.pipe";
import {TranslatePipe} from "../../../pipes/translate";
import {BookComponent} from "../../../components/book/book.component";

@Component({
	selector: "file",
	templateUrl: "../../node/file/file.component.html",
	styleUrls: ["../../node/file/file.component.scss"]
})
export class SearchResultFileComponent extends FileComponent implements OnDestroy {

	node: InputSignal<Node> = input<Node>();
	_node: Node = this.node();

	constructor(public data: DataProvider,
	            public userProvider: UserProvider,
	            public sanitizer: DomSanitizer,
	            protected router: Router,
	            protected route: ActivatedRoute,
	            protected cdr: ChangeDetectorRef,
	            protected status: AppstatusProvider,
	            private location: Location
	) {
		super(data, userProvider, sanitizer, router, route, cdr, status);
	}

	async closeModal() {
		this.location.back();
	}
}
